<template>
  <div class="main__green">
    <div
      class="h5-headline width-100 text-left py-2">
      {{ item.organizationName }}
    </div>
    <v-data-table
      calculate-widths
      class="elevation-0 main__light_green stop-table"
      disable-pagination
      :expanded.sync="expanded"
      fixed-header
      :headers="headers"
      hide-default-footer
      item-key="id"
      :items="positions"
      :loading-text="$t('Tenders.Loading')"
      :no-data-text="$t('Tenders.NoData')"
      :no-results-text="$t('Tenders.NoData')">
      <template v-slot:item="{ item: itemObject, isExpanded }">
        <tr
          :class="{'pointer': itemObject.attachmentGrop.length, 'v-data-table__expanded v-data-table__expanded__row': isExpanded}"
          @click="expandRow(itemObject)">
          <td/>
          <td class="text-left">
            {{ formDate(itemObject.dateFrom) }}
          </td>
          <td class="text-left">
            {{ date_to(itemObject) }}
          </td>
          <td class="text-left">
            {{ itemObject.addUser }}
          </td>
          <td class="text-left">
            {{ itemObject.editUser ? itemObject.editUser : itemObject.unlockedAuthomatically ? $t('StopLists.Authomatically') : '' }}
          </td>
          <td class="text-left">
            {{ itemObject.lockReason }}
          </td>
          <td>
            <span class="flex">
              <sIcon
                class="mr-1"
                :color="!itemObject.attachments.length ? 'grey' : '' "
                type="draft"/>
              {{ itemObject.attachments.length }}
            </span>
          </td>
        </tr>
      </template>
      <template #expanded-item="{ headers: expandedHeaders, item: expandedItem }">
        <tr
          v-if="expandedItem.attachmentGrop"
          class="v-data-table__expanded width-100">
          <td
            class="pa-0 expanded-table-td"
            :colspan="1"/>
          <td
            class="pa-0 expanded-table-td text-start"
            :colspan="expandedHeaders.length - 1">
            <div class="h7-text-medium black--text mb-4">
              {{ bigFirstLetter($t(`Tenders.Documents`)) }}
            </div>
            <div
              class="flex">
              <DocumentList
                v-for="(attachment, attachmentItem) in expandedItem.attachmentGrop"
                :key="`attachments-${attachmentItem}`"
                :attachments="attachment"
                :class="`doc-col-${expandedItem.attachmentGrop.length}`"
                small/>
            </div>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import DocumentList from 'components/common/blocks/DocumentList.vue'

import { modalMixin, stopListsMixin } from 'mixins'

export default {
  name: 'orgHistoryTable',
  mixins: [ modalMixin, stopListsMixin ],
  data() {
    return {
      expanded: [],
    }
  },
  props: {
    item: Object
  },
  computed: {
    headers() {
      return [
        {text: '', value: '', width: '1%', sortable: false   },
        { text: this.$t('StopLists.LockDate'), value: 'dateFrom', width: '15%', sortable: true, },
        { text: this.$t('StopLists.UnlockDate'), value: 'dateTo', width: '17%', sortable: true, },
        { text: this.$t('StopLists.WhoBlocked'), value: 'addUser', width: '17%', sortable: true, },
        { text: this.$t('StopLists.WhoUnlocked'), value: 'editUser', width: '17%', sortable: true, },
        { text: this.$t('StopLists.BlockingReason'), value: 'lockReason', width: '30%', sortable: true, },
        { text: '', value: 'attachments', width: '2%', sortable: false, },
      ]
    },
    positions() {
      const getAttachments = (item) => {
        if (!item?.attachments?.length) {
          return []
        }

        const rows = []
        const itemsCount = item?.attachments?.length
        const columnsCount = 3
        for (let i = 0; i < itemsCount; i++) {
          const rowIndex = i % columnsCount
          if (!rows[rowIndex]) {
            rows[rowIndex] = []
          }
          rows[rowIndex].push(item?.attachments?.[i])
        }
        return rows
      }
      const result = this.$_.cloneDeep(this.item.stopListBlockRows)
        .map((i) => ({
          ...i,
          attachmentGrop: getAttachments(i) || []
        }))
      return result.sort((a, b) => {
        if (a.dateFrom !== b.dateFrom) {
          return a.dateFrom > b.dateFrom ? -1 : 1
        }
        if (a.dateUnlock !== b.dateUnlock) {
          return a.dateUnlock > b.dateUnlock ? -1 : 1
        }
        if (a.dateTo !== b.dateTo) {
          return a.dateTo > b.dateTo ? -1 : 1
        }
        return 0
      })
    }
  },
  methods: {
    expandRow(item) {
      if (!item?.attachmentGrop?.length) { return }
      let ind = this.expanded.findIndex(el => el.id == item.id)
      if (ind < 0) {
        this.expanded.push(item)
      } else {
        this.expanded.splice(ind, 1)
      }
    },
  },
  components: {
    DocumentList
  }
}
</script>

<style lang="scss" scoped>
.open-docs-btn {
  min-width: unset !important;
}
td.expanded-table-td {
  padding: 0 !important;
}
.doc-col {
  &-1 {
    width: 100%;
  }
  &-2 {
    width: 50%;
  }
  &-3 {
    width: 33%;
  }
}
</style>
